import { useState } from 'react';

import {
    useGetJournalEventsContext,
    useGetJournalEventsListQuery,
} from '@entities/eventJournal/api/hooks';
import { useCalendarQueries } from '@entities/сalendar/lib/useCalendarQueries';
import { useNuqsQueryState } from '@shared/hooks';
import { useGetJournalEventsListForCustomerQuery } from '@widgets/EventJournal/api/useGetJournalEventsListForCustomer';
import {
    eventJournalModalExport,
    eventJournalModalModeQuery,
} from '@widgets/EventJournal/model/consts';

export const useExportPdfModal = () => {
    const { data } = useGetJournalEventsListQuery();
    const { state: modalMode, setState: setModalMode } = useNuqsQueryState(
        eventJournalModalModeQuery
    );

    const { dateFromQueryValue, dateToQueryValue } = useCalendarQueries();

    const isOpen = modalMode === eventJournalModalExport;
    const [isShowCustomer, setIsShowCustomer] = useState(false);
    const { dataForCustomer, isLoading } = useGetJournalEventsListForCustomerQuery(isShowCustomer);
    const { data: dataContext } = useGetJournalEventsContext();

    const onShowCustomer = () => {
        setIsShowCustomer(!isShowCustomer);
    };

    const handleClose = async () => {
        await setModalMode(null);
        setIsShowCustomer(false);
    };

    const eventsList = dataForCustomer && isShowCustomer ? dataForCustomer : data;

    return {
        data,
        setModalMode,
        isOpen,
        isShowCustomer,
        onShowCustomer,
        handleClose,
        dateFromQueryValue,
        dateToQueryValue,
        dataForCustomer,
        isLoading,
        eventsList,
        dataContext,
    };
};
